import { Moment } from 'moment';
import { ProfileMapper } from '../../../common/mappers/ProfileMapper';
import { Profile } from '../../../common/models/Profile';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Project } from '../models/Project';

export class ProjectMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly profileMapper = new ProfileMapper();

  mapGQLModel(data: any): Project {
    let lastAnalysis: Moment | null = null;
    if (data.lastAnalysis) {
      lastAnalysis = DateUtils.toMoment(data.lastAnalysis);
    }

    let defaultProfile: Profile | null = null;
    if (data.defaultProfile) {
      defaultProfile = this.profileMapper.mapGQLModel(data.defaultProfile);
    }

    return new Project(this.gqlIdEncoder.decode(data.id), data.name, lastAnalysis, defaultProfile, data.vulnerabilities?.totalCount ?? 0);
  }
}
